export function readEmployerAdApplicationCount(entry) {
  const count = Number(
    entry?.application_count
    ?? entry?.applicationCount
    ?? entry?.bewerber_count
    ?? entry?.candidate_count
    ?? entry?.totalApplications
    ?? 0
  );
  return Number.isFinite(count) ? count : 0;
}

export function formatEmployerAdFocusLabel(entry) {
  const title = entry?.titel || entry?.berufsbezeichnung || entry?.beruf_text || "Anzeige";
  const status = entry?.status || "offen";
  return `${title} (${readEmployerAdApplicationCount(entry)}) · ${status}`;
}
